import { FC, useContext, useState } from 'react'

import { Button, Icon, Menu, Span, Square } from '@chakra-ui/react'
import { MODAL_TYPES } from '@editor/config/constants'
import { GlobalModalContext } from '@editor/contexts/GlobalModal'
import { UserContext } from '@editor/contexts/Users'
import { downloadCadFile } from '@editor/services/AWS'
import { getSignedUrlForGetDownSampledFile } from '@editor/services/InspectionArea'
import { RootState } from '@editor/store/app'
import fileDownload from 'js-file-download'
import { TbCloudDownload } from 'react-icons/tb'
import { useSelector } from 'react-redux'

const DownsampledPCDExportButton: FC = () => {
  // Store
  const project = useSelector((state: RootState) => state.page.project)
  const inspectionArea = useSelector((state: RootState) => state.page.inspectionArea)

  // Context
  const { showModal, showErrorModal } = useContext(GlobalModalContext)
  const { getAccessToken } = useContext(UserContext)

  const [isLoading, setIsLoading] = useState(false)
  const [downloadText, setDownloadText] = useState(0)

  const download = async () => {
    if (!project?.project_id || !inspectionArea?.inspection_area_id) {
      showModal({
        body: '工事が存在しません。',
        modalType: MODAL_TYPES.ERROR,
      })
      return false
    }

    setIsLoading(true)

    const token = await getAccessToken()
    if (!token) {
      setIsLoading(false)
      return false
    }

    if (!inspectionArea?.down_sampled_file?.name) {
      setIsLoading(false)
      showModal({
        body: 'データが存在しません。',
        modalType: MODAL_TYPES.ERROR,
      })
      return false
    }

    //* Get signed URL for downsampled file
    const downloadUrl = await getSignedUrlForGetDownSampledFile(
      token,
      project.project_id,
      inspectionArea.inspection_area_id,
      showErrorModal,
    )
    if (!downloadUrl) {
      setIsLoading(false)
      return false
    }

    //* Download file
    const downloadResult = await downloadCadFile(downloadUrl, setDownloadText, showErrorModal)
    if (!downloadResult) {
      setIsLoading(false)
      setDownloadText(0)
      return false
    }

    const { blob, type } = downloadResult
    const fileBlob = new Blob(blob, { type })
    fileDownload(fileBlob, inspectionArea.down_sampled_file.name)

    setIsLoading(false)
    setDownloadText(0)
    return true
  }

  return (
    <Menu.Item value="downsampled-pcd-export" asChild>
      <Button onClick={download} loading={isLoading} disabled={isLoading} data-testid="downsampled-pcd-export-button">
        <Square className="icon-wrapper">
          <Icon as={TbCloudDownload} boxSize="1.1rem" />
        </Square>
        <Span>{downloadText ? `ダウンロード中...${downloadText}%` : 'Downsampled PCD'}</Span>
      </Button>
    </Menu.Item>
  )
}

export default DownsampledPCDExportButton
